import React from 'react';
import img from '../../images/banner/order.jpg'

const PlaceOrder = () => {
    return (
        <div>
            <img width="50%" height="50%" src={img} alt="" />
        </div>
    );
};

export default PlaceOrder;